"use client";
import { useEffect, useState } from "react";
import styles from "./MaskedCircleHero.module.scss";
import { crushBlacksToDataURL } from "./crushBlacksToDataURL";

export default function MaskedCircleHero({ src, alt, height = "100dvh" }: any) {
  const [processed, setProcessed] = useState<string>(src);

  useEffect(() => {
    let cancelled = false;

    crushBlacksToDataURL(src, { blackPoint: 45, gamma: 1.12, contrast: 1.15 })
      .then((url) => {
        if (!cancelled) setProcessed(url);
      })
      .catch(() => setProcessed(src));

    return () => {
      cancelled = true;
    };
  }, [src]);

  return (
    <section className={styles.hero} style={{ minHeight: height }}>
      <div className={styles.centerWrap} style={{ minHeight: height }}>
        <div className={styles.circleFrame}>
          <img src={processed} alt={alt} className={styles.image} />
          <span className={styles.edgeFade} />
        </div>
      </div>
    </section>
  );
}
